import { render, staticRenderFns } from "./customer-statement.vue?vue&type=template&id=6d5a8b6e&"
import script from "./customer-statement.vue?vue&type=script&lang=js&"
export * from "./customer-statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports